// extracted by mini-css-extract-plugin
module.exports = {"requisition-info-card":"styles-module__requisition-info-card___195dP","requisition-documents-card":"styles-module__requisition-documents-card___Fqmyi"};